import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { getFileExtensionFromUrl } from "../../../helpers";
import { IBankDebitCredit, IGeneralLedgerDetail } from "./BankDebitCredit.types";

export const FETCH_BANK_DEBIT_CREDIT_LIST_PROGRESS =
  "FETCH_BANK_DEBIT_CREDIT_LIST_PROGRESS";
export const FETCH_BANK_DEBIT_CREDIT_LIST_SUCCESS =
  "FETCH_BANK_DEBIT_CREDIT_LIST_SUCCESS";
export const FETCH_BANK_DEBIT_CREDIT_LIST_FAILED =
  "FETCH_BANK_DEBIT_CREDIT_LIST_FAILED";

export const fetchBankDebitCreditListProgress = () =>
  action(FETCH_BANK_DEBIT_CREDIT_LIST_PROGRESS);
export const fetchBankDebitCreditListSuccess = (
  data: IBankDebitCredit[],
  totalRecords: number
) => action(FETCH_BANK_DEBIT_CREDIT_LIST_SUCCESS, { data, totalRecords });
export const fetchBankDebitCreditListFailed = () =>
  action(FETCH_BANK_DEBIT_CREDIT_LIST_FAILED);

export const fetchBankDebitCreditListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date,bank_account } = searchState;
      dispatch(fetchBankDebitCreditListProgress());
      let finalUrl = `/accounting/get-bank-debit-credit?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;
     if(bank_account){
       finalUrl = finalUrl+"&bank_account="+bank_account
     }
      if (searchValue.length > 0) {
        finalUrl = finalUrl+`&advanceFilter=${JSON.stringify(
          searchValue
        )}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      // if (from_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "GREATER_THAN_EQUAL",
      //     value: from_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }
      // if (to_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "LESSER_THAN_EQUAL",
      //     value: to_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }
      const res = await api.get(finalUrl);
      const data: IBankDebitCredit[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchBankDebitCreditListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchBankDebitCreditListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };


  export const fetchBankDebitCreditPDFAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    searchState: { [key: string]: any },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date,bank_account } = searchState;
      dispatch(saveLoaderProgress());

      let finalUrl = `accounting/get-bank-debit-credit-pdf?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;
     
  if(bank_account){
       finalUrl = finalUrl+"&bank_account="+bank_account
     }
       const res = await api.get(finalUrl, {
             responseType: "arraybuffer",
           });
     
           const blob = new Blob([res.data], {
             type: "application/" + getFileExtensionFromUrl("Balance_sheet.pdf"),
           });
           // const blob = new Blob([res.data], { type: "application/octet-stream" });
           const url = window.URL.createObjectURL(blob);
     
           // Create a link element and simulate a click to trigger the download
           const link = document.createElement("a");
           link.href = url;
          link.setAttribute("download", "Bank Transactions.pdf");// Set the desired file name and extension
           document.body.appendChild(link);
           link.click();
     
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_GL_DETAILS_LIST_PROGRESS =
  "FETCH_GL_DETAILS_LIST_PROGRESS";
export const FETCH_GL_DETAILS_LIST_SUCCESS =
  "FETCH_GL_DETAILS_LIST_SUCCESS";
export const FETCH_GL_DETAILS_LIST_FAILED =
  "FETCH_GL_DETAILS_LIST_FAILED";

export const fetchGLDetailsListProgress = () =>
  action(FETCH_GL_DETAILS_LIST_PROGRESS);
export const fetchGLDetailsListSuccess = (
  data: IGeneralLedgerDetail[],
  totalRecords: number
) => action(FETCH_GL_DETAILS_LIST_SUCCESS, { data, totalRecords });
export const fetchGLDetailsListFailed = () =>
  action(FETCH_GL_DETAILS_LIST_FAILED);

export const fetchGLDetailsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date,gl_account_code } = searchState;
      dispatch(fetchGLDetailsListProgress());
      let finalUrl = `/accounting/get-gl-invoice-entry?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;
   
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-gl-invoice-entry?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&advanceFilter=${JSON.stringify(
          searchValue
        )}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      if(gl_account_code){
        const data = gl_account_code.split("-");
        if(data.length> 0){
             finalUrl= finalUrl+"&gl_account_code="+data[1]
        }
      }
      // if (from_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "GREATER_THAN_EQUAL",
      //     value: from_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }
      // if (to_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "LESSER_THAN_EQUAL",
      //     value: to_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }
      const res = await api.get(finalUrl);
      const data: IGeneralLedgerDetail[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchGLDetailsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchGLDetailsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  export const fetchGLDetailsListDownloadPDFAsync =
  (
    searchState: { [key: string]: any },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date,gl_account_code } = searchState;
      let code = "";
      if(gl_account_code){
        const data = gl_account_code.split("-");
        if(data.length> 0){
             code=data[1]
        }
      }
      dispatch(saveLoaderProgress());

      const finalUrl = `/accounting/get-gl-invoice-entry-pdf?gl_account_code=${code}&from_date=${from_date}&to_date=${to_date}`;
     

       const res = await api.get(finalUrl, {
             responseType: "arraybuffer",
           });
     
           const blob = new Blob([res.data], {
             type: "application/" + getFileExtensionFromUrl(`GL Detail ${code}.pdf`),
           });
           // const blob = new Blob([res.data], { type: "application/octet-stream" });
           const url = window.URL.createObjectURL(blob);
     
           // Create a link element and simulate a click to trigger the download
           const link = document.createElement("a");
           link.href = url;
          link.setAttribute("download", `GL Detail ${code}.pdf`);// Set the desired file name and extension
           document.body.appendChild(link);
           link.click();
     
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchBankDebitCreditListForExportAsync =
  (
    searchState: { [key: string]: any },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date } = searchState;
      dispatch(saveLoaderProgress());

      const finalUrl = `/accounting/get-bank-debit-credit?from_date=${from_date}&to_date=${to_date}`;
     

       const res = await api.get(finalUrl, {
             responseType: "arraybuffer",
           });
     
           const blob = new Blob([res.data], {
             type: "application/" + getFileExtensionFromUrl("Balance_sheet.pdf"),
           });
           // const blob = new Blob([res.data], { type: "application/octet-stream" });
           const url = window.URL.createObjectURL(blob);
     
           // Create a link element and simulate a click to trigger the download
           const link = document.createElement("a");
           link.href = url;
          link.setAttribute("download", "Balance_sheet.pdf");// Set the desired file name and extension
           document.body.appendChild(link);
           link.click();
     
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_BANK_DEBIT_CREDIT_STATEMENTS = "CLEAR_BANK_DEBIT_CREDIT_STATEMENTS";
export const clearBankDebitCredit = () =>
  action(CLEAR_BANK_DEBIT_CREDIT_STATEMENTS);
